// extracted by mini-css-extract-plugin
module.exports = {"modal":"GetBookModal_modal__8VUU_","container":"GetBookModal_container___fjGj","image":"GetBookModal_image__b86rv","backButton":"GetBookModal_backButton__bQgiS"};